import { useDelayedRender } from '~hooks/common';

const DelayedRender = ({ delay, children }) => useDelayedRender(delay)(() => children);

export default DelayedRender;
